var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3553 21.6562C12.7697 21.4369 22.5 16.125 22.5 9.5625C22.4983 8.02146 21.8853 6.54404 20.7956 5.45436C19.706 4.36468 18.2285 3.75174 16.6875 3.75C15.4966 3.75 14.3968 4.06504 13.4808 4.63512C12.9077 4.99174 12.4066 5.44816 12 5.98969C11.5934 5.44816 11.0923 4.99174 10.5192 4.63512C9.60318 4.06504 8.50343 3.75 7.3125 3.75C5.77146 3.75174 4.29404 4.36468 3.20436 5.45436C2.11468 6.54404 1.50174 8.02146 1.5 9.5625C1.5 16.125 11.2303 21.4369 11.6447 21.6562C11.7539 21.715 11.876 21.7458 12 21.7458C12.124 21.7458 12.2461 21.715 12.3553 21.6562ZM3.5 9.56362C3.50144 8.55264 3.90368 7.58346 4.61857 6.86857C5.33347 6.15368 6.30264 5.75144 7.31362 5.75C8.66457 5.75032 9.74805 6.32139 10.4006 7.19054L12 9.32065L13.5994 7.19054C14.2519 6.32139 15.3354 5.75032 16.6864 5.75C17.6974 5.75144 18.6665 6.15368 19.3814 6.86857C20.0962 7.58338 20.4985 8.55242 20.5 9.56326C20.4996 11.9084 18.6912 14.3591 16.2654 16.4835C14.5854 17.9547 12.8713 19.0417 12 19.5577C11.1287 19.0417 9.41458 17.9547 7.73461 16.4835C5.30894 14.3592 3.50058 11.9087 3.5 9.56362Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIHeart);
export default __webpack_public_path__ + "static/media/IHeart.1c8e7fc7315721e42c20f3f96a5a04cf.svg";
export { ForwardRef as ReactComponent };